import {useSelector} from 'react-redux'
import {getIsDatesVisible} from 'modules/searchBox/selectors'

import {useIsSeoSRP} from './useIsSeoSRP'

export type SRPSearchFlow = 'regular' | 'seo'

/**
 * Returns the current SRP search flow type: `'seo'` or `'regular'`.
 *
 * - `'seo'`: the user landed on the SRP via a SEO page (e.g. /p/47319/en/the-netherlands/amsterdam).
 * - `'regular'`: the user reached the SRP through a standard search.
 *
 * When dates are visible (checkin/checkout params are present), the flow is considered `'regular'`
 * even on a SEO SRP, since the user has landed with dates. example: /p/47319/en/the-netherlands/amsterdam?checkIn=2026-05-13&checkOut=2026-05-15
 *
 * This value is forwarded as the `srpSearchFlow` query parameter when navigating to the AP,
 * so downstream hooks (e.g. `useIsSrpSearchSeoFlow`) can adapt behavior accordingly
 * (breadcrumbs, back button navigation, facility links).
 */
export const useGetSRPSearchFlow = (): SRPSearchFlow => {
  const isSeoSRP = useIsSeoSRP()
  const isDatesVisible = useSelector(getIsDatesVisible)

  return !isDatesVisible && isSeoSRP ? 'seo' : 'regular'
}
